import React, { Dispatch, SetStateAction } from 'react';

import { Button } from '@lightspeed/flame/Button';
import { Flex } from '@lightspeed/flame/Core';
import { Group } from '@lightspeed/flame/Group';
import { ModalBody, ModalFooter, ModalHeader } from '@lightspeed/flame/Modal';
import { Text } from '@lightspeed/flame/Text';

import { StyledCancelDepositModal } from './AddPaymentDepositModal.style';

interface CancelDepositModal {
  isModalOpen: boolean;
  previousModalView: string;
  handleCloseModal: () => void;
  setModalView: Dispatch<SetStateAction<string>>;
}

const CancelDepositModal: React.FC<CancelDepositModal> = ({
  isModalOpen,
  handleCloseModal,
  setModalView,
  previousModalView,
}) => {
  return (
    <StyledCancelDepositModal isOpen={isModalOpen} shouldCloseOnOverlayClick={false}>
      <ModalHeader showCloseButton={false} data-test="cancel-deposit-modal-header">
        <Text fontSize="16px" fontWeight="bold">
          Cancel deposit?
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text fontSize="14px">
          The remote deposit won’t be added to your sale and no link will be generated.
        </Text>
      </ModalBody>
      <ModalFooter>
        <Flex justifyContent="right">
          <Group>
            <Button
              onClick={() => setModalView(previousModalView)}
              data-test="cancel-deposit-modal-back-btn"
            >
              Back
            </Button>
            <Button
              width="128px"
              height="36px"
              variant="danger"
              fill
              p={0}
              onClick={() => handleCloseModal()}
              data-test="cancel-deposit-modal-cancel-btn"
            >
              Cancel deposit
            </Button>
          </Group>
        </Flex>
      </ModalFooter>
    </StyledCancelDepositModal>
  );
};

export default CancelDepositModal;
